import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Spin } from "antd";
import login_page_img from "./assets/login_page_img.webp";
import DemoLoginFormComponent from "./demoform/DemoLoginFormComponent";
import "./styles/demologinpage.css";
import { useAuth } from "../../generic/hooks/useAuth";
import { useNavigate } from "react-router";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import { startAuthentication } from "@simplewebauthn/browser";
import { clearLocalStorage } from "../logout/utils";
import { useWriteMemory } from "../../generic/hooks/useWriteMemory";

const DemoLoginPage = () => {
  const navigate = useNavigate();
  const setMemory = useWriteMemory();
  const loggedIn = useAuth();
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return loggedIn;
  });
  const didRunRef = useRef(false);
  const isAuthInProgressRef = useRef(false);
  const challenge = useReadMemory(MemoryType.CHALLENGE);
  const userJson = useReadMemory(MemoryType.USER);

  const handleWebAuthn = async () => {
    if (isAuthInProgressRef.current) return;
    isAuthInProgressRef.current = true;

    try {
      const options = {
        challenge: btoa(crypto.randomUUID()),
        rpId: window.location.hostname,
        userVerification: "required",
        allowCredentials: [
          {
            id: challenge.id,
            type: "public-key",
          },
        ],
      };

      const authResult = await startAuthentication(options);
      return authResult;
    } catch (error) {
      navigate("/authenticate");
    } finally {
      isAuthInProgressRef.current = false;
    }
  };

  useEffect(() => {
    localStorage.removeItem(MemoryType.AUTH);
  }, []);

  useEffect(() => {
    if (!isLoggedIn || didRunRef.current) return;
    didRunRef.current = true;

    const authenticateUser = async () => {
      if (challenge) {
        const isAuthenticated = await handleWebAuthn();
        if (isAuthenticated) {
          setMemory(MemoryType.AUTH, userJson);
          navigate(RoleToLinkMapper(userJson?.jobTitle) + "homepage", {
            replace: true,
          });
        } else {
          navigate("/authenticate");
        }
      } else if (userJson?.hasPin) {
        navigate("/authenticate");
      } else {
        clearLocalStorage();
        setIsLoggedIn(false);
      }
    };

    authenticateUser();
  }, [isLoggedIn, challenge, userJson, navigate]);

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        {isLoggedIn ? (
          <Spin size="large" className="spinnerCenter" />
        ) : (
          <Row justify="space-between" className="main-layout">
            <Col xs={24} lg={12} className="demoform-component">
              <DemoLoginFormComponent />
            </Col>
            <Col lg={12} xs={0} className="image-column">
              <img src={login_page_img} alt="Signup form" loading="lazy" />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default DemoLoginPage;
